import { Route } from '@angular/router';
import { RenderEngineComponent } from '../../pages/render-engine/render-engine.component';
import { ModuleType } from '../../core/enums/module-type.enum';
import { PageType } from '../../core/enums/page-type.enum';

export const ORDER_ROUTES: Route[] = [
  {
    path: 'cart',
    component: RenderEngineComponent,
  },
  {
    path: 'address',
    component: RenderEngineComponent,
    children: [
      {
        path: 'new/:type',
        component: RenderEngineComponent,
      },

      {
        path: 'edit/:addressId',
        component: RenderEngineComponent,
      },
    ],
  },
  {
    path: 'payment',
    component: RenderEngineComponent,
  },
  {
    path: 'book/:orderId',
    component: RenderEngineComponent,
    data: {
      pageType: PageType.ORDER,
      module: ModuleType.ORDER,
    },
  },

  //   Default Routes
  {
    path: '**',
    component: RenderEngineComponent,
  },
];
